import React, { useEffect } from 'react';
import { Badge } from 'react-bootstrap';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';
import ExcelFileStatus from '../../../../app/support/ExcelFileStatus';

const mapState = (store) => {
  return store.modulo.timbrado_masivo.archivos;
};

const mapActions = (actions) => {
  return { ...actions.modulo.timbrado_masivo.archivos };
};

const TimbradoMasivoList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      actions.paginate({
        page: 1,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { filters } = state;

    actions.paginate({
      ...filters,
      ...meta,
    });
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const setSelectedRows = (event) => {
    actions.setSelectedRows(event);

    !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  };

  const getRowSelectionConfig = () => {
    const { selectedRowKeys = [] } = props;

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: setSelectedRows,
      getCheckboxProps: (record) => ({
        name: record.name,
      }),
    };
  };

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      rowSelection={getRowSelectionConfig()}
    ></Table>
  );
};

const renderStatus = (item) => {
  let variant = 'light';

  const status = ExcelFileStatus.search(item.status);

  if (status.isProcessed()) {
    variant = 'success';
  } else if (status.isError()) {
    variant = 'danger';
  } else if (!status.isPending()) {
    variant = 'info';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

const renderTipo = (item) => {
  return item.tipo.replace('timbrado-', '');
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
  },
  {
    key: 'filename',
    title: 'Archivo',
    dataIndex: 'filename',
  },
  {
    key: 'tipo',
    title: 'Tipo',
    dataIndex: 'tipo',
    render: renderTipo,
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'center',
  },
  {
    key: 'subidos',
    title: 'Subidos',
    dataIndex: 'subidos',
    align: 'center',
  },
  {
    key: 'procesados',
    title: 'Procesados',
    dataIndex: 'procesados',
    align: 'center',
  },
  {
    key: 'timbrados',
    title: 'Timbrados',
    dataIndex: 'timbrados',
    align: 'center',
  },
  {
    key: 'errores',
    title: 'Errores',
    dataIndex: 'errores',
    align: 'center',
  },
  {
    key: 'duplicados',
    title: 'Duplicados',
    dataIndex: 'duplicados',
    align: 'center',
  },
  // {
  //   key: 'bloqueados',
  //   title: 'Bloqueados',
  //   dataIndex: 'bloqueados',
  //   align: 'center'
  // },
  // {
  //   key: 'vacios',
  //   title: 'Vacíos',
  //   dataIndex: 'vacios',
  //   align: 'center'
  // },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: renderStatus,
  },
];

export default TimbradoMasivoList;
